import React, { useContext } from 'react'
import { type FormStepProps, OdysseyContext } from '@redventures/odyssey'
import { TextField } from '@strata-monorepo/shared-ui/components/TextField/TextField'

const TemperatureQuestion: React.FC<FormStepProps> = () => {
  const odysseyContext = useContext(OdysseyContext)

  return (
    <div className='strata:flex strata:flex-col strata:@qs/qc:flex-row strata:@qs/qc:gap-6 strata:gap-2 strata:mt-3 strata:justify-center strata:items-center'>
      {/* Summer Temperature */}
      <div className='strata:flex-1 strata:w-full'>
        <label
          htmlFor='summerTemp'
          className='strata:text-left strata:block strata:text-gray-700 strata:text-sm strata:pb-0.5 strata:@qm/qc:pb-1'
        >
          Summer temp.
        </label>
        <div className='strata:relative'>
          <TextField
            id='summerTemp'
            type='number'
            value={(odysseyContext?.getValue('summerTemp') as string) || ''}
            placeholder='Enter temperature'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              odysseyContext?.setValue('summerTemp', e.target.value)
            }
            className='strata:border-gray-400 strata:placeholder:text-gray-600 strata:border strata:w-full strata:px-4 strata:py-3 strata:text-md strata:rounded-[8px] strata:focus:border-gray-400 strata:hover:ring-[1px] strata:hover:ring-system-information-accent strata:ring-offset-4'
          />
          <span className='strata:absolute strata:right-4 strata:top-1/2 strata:transform strata:-translate-y-1/2 strata:text-md strata:font-bold strata:text-gray-700'>
            °F
          </span>
        </div>
        <p className='strata:text-left strata:text-system-negative-foreground strata:text-body-xs strata:pt-0.5 strata:@qm/qc:pt-1'>
          {odysseyContext?.getError('summerTemp')}
        </p>
      </div>

      {/* Winter Temperature */}
      <div className='strata:flex-1 strata:w-full'>
        <label
          htmlFor='winterTemp'
          className='strata:text-left strata:block strata:text-gray-700 strata:text-sm strata:pb-0.5 strata:@qm/qc:pb-1'
        >
          Winter temp.
        </label>
        <div className='strata:relative'>
          <TextField
            id='winterTemp'
            type='number'
            value={(odysseyContext?.getValue('winterTemp') as string) || ''}
            placeholder='Enter temperature'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              odysseyContext?.setValue('winterTemp', e.target.value)
            }
            className='strata:border-gray-400 strata:placeholder:text-gray-600 strata:border strata:w-full strata:px-4 strata:py-3 strata:text-md strata:rounded-[8px] strata:focus:border-gray-400 strata:hover:ring-[1px] strata:hover:ring-system-information-accent strata:ring-offset-4'
          />
          <span className='strata:absolute strata:right-4 strata:top-1/2 strata:transform strata:-translate-y-1/2 strata:text-md strata:font-bold strata:text-gray-700'>
            °F
          </span>
        </div>
        <p className='strata:text-left strata:text-system-negative-foreground strata:text-body-xs strata:pt-0.5 strata:@qm/qc:pt-1'>
          {odysseyContext?.getError('winterTemp')}
        </p>
      </div>
    </div>
  )
}

export default TemperatureQuestion
